import { Button, Flex, Heading, Image, Text } from '@chakra-ui/react';
import { useEffect } from 'react';

import logo from '@/assets/images/logo_main.png';
import { captureSentry } from '@/utils/helpers/sentryHelper';

type Props = {
  error: { message?: string };
  resetErrorBoundary: () => void;
};

export const ErrorFallback = ({ error, resetErrorBoundary }: Props) => {
  useEffect(() => {
    captureSentry({
      title: 'Error boundary triggered',
      detail: {
        message: error.message,
      },
      error,
    });
  }, [error]);
  return (
    <Flex direction="column" width="100%" height="60vh" alignItems="center" justifyContent="center">
      <Image alt="Livelinx logo" width="150px" src={logo} />
      <Heading>Please excuse us, something went wrong during your experience</Heading>
      <Text>This has been reported automatically</Text>
      <pre>{error.message}</pre>
      <Button variant="ghost" onClick={resetErrorBoundary}>
        Try again
      </Button>
    </Flex>
  );
};
